import styled from 'styled-components';

import { Country, Flex, spaces, Text } from '@electricjs/arc';

import { getCountryName } from '@/helpers/getCountryName';

const CountryOption = styled(Flex)<{ $isSelected?: boolean }>`
  align-items: center;
  justify-content: space-between;
  padding: ${spaces.space_2xs} 0;
  cursor: ${({ $isSelected }) => ($isSelected ? 'not-allowed' : 'pointer')};
`;

const CountryFlag = styled.span<{ $isSelected?: boolean }>`
  font-size: ${spaces.space_l};
  ${({ $isSelected }) =>
    $isSelected &&
    `
    filter: grayscale(100%);
    opacity: 0.6;
  `}
`;

type CountryOptionProps = {
  country: {
    code: string;
    name: string;
    flag: string;
    phoneCode: string;
  };
  isSelected?: boolean;
  showPhoneCode?: boolean;
};

const CustomCountryOption = ({
  country,
  isSelected,
  showPhoneCode,
}: CountryOptionProps) => {
  return (
    <CountryOption $isSelected={isSelected}>
      <Flex alignItems="center" gap={spaces.space_xs}>
        <CountryFlag $isSelected={isSelected}>{country.flag}</CountryFlag>
        <Text variant="body" intent={isSelected ? 'disabled' : undefined}>
          {getCountryName(country.code as Country)}
        </Text>
      </Flex>
      {showPhoneCode && (
        <Text variant="body" intent={isSelected ? 'disabled' : undefined}>
          {country.phoneCode}
        </Text>
      )}
    </CountryOption>
  );
};

export default CustomCountryOption;
